export class CreateApiCredentialsRequest {
    'name';
    'roleId';
    'projects';
    'expiresAt';
    'enableCurrentSecretRotation';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "roleId",
            "baseName": "roleId",
            "type": "string",
            "format": ""
        },
        {
            "name": "projects",
            "baseName": "projects",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "expiresAt",
            "baseName": "expiresAt",
            "type": "string",
            "format": ""
        },
        {
            "name": "enableCurrentSecretRotation",
            "baseName": "enableCurrentSecretRotation",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateApiCredentialsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
